import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export default {
    actions,
    state,
    mutations,
    getters,
    namespaced: true
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/MySubscriptions/index.js